import Proximity, { IStateChangeMessage as IProximityStateChangeMessage } from './Proximity';

type ISensorMessage = IProximityStateChangeMessage;

export default class Sensors {
	public static MESSAGE_PREFIX: string = 'sensors';

	public readonly proximity: Proximity;

	/** @internal */
	constructor(private messagePrefix: string) {
		this.proximity = new Proximity(this.getMessagePrefix());
	}

	/** @internal */
	public handleMessageData(data: ISensorMessage) {
		this.proximity.handleMessageData(data as IProximityStateChangeMessage);
	}

	private getMessagePrefix() {
		return this.messagePrefix + '.' + Sensors.MESSAGE_PREFIX;
	}
}
